import EChartsReact from 'echarts-for-react'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'

export default observer(function Hashtags({ currentAuthentication }) {

  const authenticationsHashtags = useMemo(() => currentAuthentication.authentications_hashtags, [currentAuthentication.authentications_hashtags, currentAuthentication.authentications_hashtags.length])
  const hashtagNames = useMemo(() => authenticationsHashtags.map((authenticationsHashtag) => `#${authenticationsHashtag.hashtag.name}`), [authenticationsHashtags, authenticationsHashtags.length])
  const percentages = useMemo(() => authenticationsHashtags.map((authenticationsHashtag) => authenticationsHashtag.percentage), [authenticationsHashtags, authenticationsHashtags.length])

  const option = useMemo(() => ({
    xAxis: {
      axisLabel: {
        interval: 0,
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
    },
    yAxis: {
      axisLabel: {
        interval: 0,
      },
      data: hashtagNames,
      inverse: true,
      type: 'category',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    series: [
      {
        data: percentages,
        type: 'bar',
        itemStyle: {
          barBorderRadius: [0, 10, 10, 0],
          borderWidth: 1,
          borderType: 'solid',
          borderColor: '#2CCDB4',
          color: '#2CCDB4'
        },
      }
    ],
    tooltip: {
      trigger: 'item',
      formatter: '{c}%'
    },
    grid: {
      containLabel: true
    },
    textStyle: {
      fontSize: 10,
      fontWeight: 'bold'
    }
  }), [hashtagNames])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-2" style={{ gridRow: 7 }}>
      <div className="w-1/4 mb-4 flex items-center p-4">
        <div className="text-gray-400 dark:text-gray-500 mr-2">
          #
        </div>
        <p className="font-bold text-xl dark:text-white"> Hashtags</p>
      </div>

      <div>
        <EChartsReact option={option} style={{ width: '100%', height: hashtagNames.length * 20 + 150 }} />
      </div>
    </div>
  )
})